/**
 * gsap-parallax.js
 * Loads GSAP + ScrollTrigger from the CDN and applies a subtle scroll parallax
 * to every .banner__media image inside an image-banner section.
 *
 * The image is pre-scaled to 110% in CSS and GSAP scrubs its y position as
 * the banner moves through the viewport.
 */

(function () {
  'use strict';

  // Respect reduced-motion preference
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const GSAP_CDN = 'https://cdn.jsdelivr.net/npm/gsap@3.14.1/dist/gsap.min.js';
  const ST_CDN   = 'https://cdn.jsdelivr.net/npm/gsap@3.14.1/dist/ScrollTrigger.min.js';

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.onload  = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function initParallax() {
    var gsap          = window.gsap;
    var ScrollTrigger = window.ScrollTrigger;

    gsap.registerPlugin(ScrollTrigger);

    // ── Banner parallax ──────────────────────────────────────────────────────
    var mediaContainers = document.querySelectorAll('.banner .banner__media');

    mediaContainers.forEach(function (container) {
      var img = container.querySelector('img');
      if (!img) return;

      // CSS pre-sets translateY(+5%) scale(1.1); GSAP scrubs to -5% (inverted).
      gsap.to(img, {
        yPercent: -5,
        ease: 'none',
        scrollTrigger: {
          trigger: container,
          start: 'top bottom',
          end:   'bottom top',
          scrub: true,
        },
      });
    });

    // ── Multicolumn parallax ─────────────────────────────────────────────────
    // Exclude .multicolumn-contact: its images live near the viewport top on
    // the contact page, so parallax looks wrong there.
    var multicolumnWrappers = Array.from(document.querySelectorAll(
      '.multicolumn-card__image-wrapper, .multicolumn-gallery-card__image-wrapper'
    )).filter(function (w) {
      return !w.closest('.multicolumn-contact') && !w.classList.contains('no-parallax');
    });

    multicolumnWrappers.forEach(function (wrapper) {
      // Image may be a direct child or inside a .media element, or inside an
      // <a> link when image_clickable is enabled. Using fromTo makes GSAP own
      // the full transform (including scale) regardless of the DOM structure,
      // so the CSS pre-state selector never needs to match.
      var img = wrapper.querySelector('img');
      if (!img) return;

      gsap.fromTo(img,
        { yPercent: 5, scale: 1.1 },
        {
          yPercent: -5,
          scale: 1.1,
          ease: 'none',
          scrollTrigger: {
            trigger: wrapper,
            start: 'top bottom',
            end:   'bottom top',
            scrub: true,
          },
        }
      );
    });

    // ── Lookbook parallax ────────────────────────────────────────────────────
    var lookbookWrappers = document.querySelectorAll('.lookbook-card__media-wrapper');

    lookbookWrappers.forEach(function (wrapper) {
      // Only parallax the primary image — hover image has its own opacity transition
      var img = wrapper.querySelector('.lookbook-card__image--primary img');
      if (!img) return;

      gsap.to(img, {
        yPercent: -5,
        ease: 'none',
        scrollTrigger: {
          trigger: wrapper,
          start: 'top bottom',
          end:   'bottom top',
          scrub: true,
        },
      });
    });

    // Wait for ScrollTrigger to finish calculating all scroll positions,
    // then fade the banners in — guaranteeing the scrub positions are already
    // correct before anything becomes visible.
    ScrollTrigger.refresh();
    ScrollTrigger.addEventListener('refresh', function onReady() {
      ScrollTrigger.removeEventListener('refresh', onReady);
      gsap.to('.banner', {
        opacity: 1,
        duration: 0.2,
        ease: 'none',
      });
    });
  }

  // Load GSAP core first, then ScrollTrigger, then run
  loadScript(GSAP_CDN)
    .then(function () { return loadScript(ST_CDN); })
    .then(initParallax)
    .catch(function (err) {
      console.warn('[gsap-parallax] Failed to load GSAP:', err);
    });
})();
